module.exports = __webpack_public_path__ + "static/media/home_pie_icon.386d70bf.png";